import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatError } from "../../lib/api";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { await login(email, password); nav("/admin"); }
    catch (err) { setError(formatError(err.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-sand px-4">
      <div className="w-full max-w-md bg-white rounded-xl2 border border-line shadow-lift p-8">
        <img src="/logo.png" alt="GNONS" className="h-12 mx-auto mb-6" />
        <h1 className="text-xl font-bold text-ink text-center">Admin Login</h1>
        <p className="text-sm text-muted text-center mt-1 mb-6">Sign in to manage your website</p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input data-testid="admin-email" type="email" className="w-full rounded-lg border border-line px-4 py-3 text-sm focus:border-gold outline-none" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="admin-password" type="password" className="w-full rounded-lg border border-line px-4 py-3 text-sm focus:border-gold outline-none" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          {error && <p data-testid="admin-login-error" className="text-sm text-red-500">{error}</p>}
          <button type="submit" data-testid="admin-login-submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold text-white font-semibold py-3 hover:bg-gold-dark disabled:opacity-70">
            {loading ? <><Loader2 size={18} className="animate-spin" /> Signing in...</> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
